var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('router-link',{attrs:{"to":{ name: 'main' }}},[_c('img',{attrs:{"src":require("../../assets/img/logo.svg")}})]),_c('SWButton',{attrs:{"variant":'secondary',"href":_vm.loginUrl}},[_vm._v(" Login ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }